import { getRentProjection } from '@lib/api';
import { useMutation } from 'react-query';

export const useRealEstateMutation = ({
  unitId,
  marketName,
  getValues,
}: {
  unitId: string | undefined;
  marketName: string | undefined;
  getValues: () => any;
}) => {
  return useMutation(async () => {
    const formValues = getValues();
    const data = {
      ...formValues,
      unitId: unitId ?? undefined,
      market_name: marketName ?? undefined,
    };
    return await getRentProjection(data);
  });
};
